<template>
  <nuxt></nuxt>
</template>

<style>

  body {
    margin: 0;
    padding: 0;
  }

</style>

<script>

export default {}

</script>
